// extracted by mini-css-extract-plugin
export default {"loader":"DbiLoader_loader__aAASi","icon":"DbiLoader_icon__uJVHT","spin":"DbiLoader_spin__y0tAP"};